// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__y8dut","sign":"Placeholder_sign__n6D8O","arrow":"Placeholder_arrow__PJsBC"};